<template>
  <div class="user-ctn d-flex align-center pr-2" @click="$modal.open('account', {maxWidth: 1000})">
    <UserAvatar class="mr-2" :user="user" />
    <Username :user="user" />
    <v-tooltip left color="primary500">
      <template #activator="{on}">
        <fai
          :icon="['fad', 'sign-out']" fixed-width
          class="primary400--text link text-body-1 ml-2"
          v-on="on"
          @click.stop="logout"
        />
      </template>
      <span v-text="$t('cta.logout')" />
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  components: {},
  props: {
    user: {
      type: Object,
      default: null,
    },
  },
  methods: {
    ...mapActions({
      logout: 'user/logout',
    }),
  },
}
</script>

<style lang="scss" scoped>
  .user-ctn {
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: grey(800);
    }
  }
</style>
